/* eslint-disable react/no-unescaped-entities */
import Link from 'next/link'
import react from 'react'

interface BingConnectedAppProps {
  id?: string
  customerId?: string
  customerAccountId?: string
  isConnected?: boolean
  sessionId?: string
  oauthCallbackBaseUrl?: string
  clientId?: string
}

const BingConnectedApp = (props: BingConnectedAppProps) => {

  const [infoHidden, setInfoHidden] = react.useState(true)
  const [id, setId] = react.useState(props.id)
  const [customerId, setCustomerId] = react.useState(props.customerId)
  const [customerAccountId, setCustomerAccountId] = react.useState(props.customerAccountId)
  const [saved, setSaved] = react.useState(false)
  const [isConnected, setIsConnected] = react.useState(props.isConnected)
  const [error, setError] = react.useState('')

	async function handleSaveConfigData(data: {[key: string]: any}) {
    // Post data
		const resp = await fetch(`/api/bing/data`, {
			method: 'post',
			headers: {
				Session: props.sessionId!,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({id, ...data})
		})

    // Handle errors
    if (!resp.ok) {
      console.error('Failed to save config data', resp)
      setError('Failed to save config data')
      return
    }

    // Parse results
    const json = await resp.json()
    console.info('saved config data', json)
    setId(json.id)

    // Provide user feedback
    setSaved(true)

    setTimeout(() => {
      setSaved(false)
    }, 4000)

    setError('')

		return json.success
	}

  async function handleDeleteConnection() {
    const resp = await fetch(`/api/bing/data`, {
      method: 'delete',
      headers: {
				Session: props.sessionId!,
      }
    })

    if (resp.ok) {
      setIsConnected(false)
    } else {
      console.error('error deleting connection', await resp.text())
      setError('Error deleting connection')
    }
  }

  const handleExtractUrl = (url: string) => {
    // https://ui.ads.microsoft.com/campaign/vnext/overview?aid=YOUR_ACCOUNT_ID&cid=YOUR_CUSTOMER_ID&uid=8675309
    const parsed = new URL(url)
    const acctId = parsed.searchParams.get('aid')
    const customerId = parsed.searchParams.get('cid')
    setCustomerAccountId(acctId!)
    setCustomerId(customerId!)
  }

  react.useEffect(() => {
    console.log('updating state', props)
    setId(props.id)
    setCustomerId(props.customerId)
    setCustomerAccountId(props.customerAccountId)
    setIsConnected(props.isConnected)
  }, [props.id, props.customerId, props.customerAccountId, props.isConnected])

  return (
    <div
    className='border-b border-gray-300 mb-5 bg-slate-200 p-8'
   >
   <h2 className="text-2xl text-slate-500">
     <span className="text-yellow-600 font-extrabold">Bing</span>
     <button className='underline text-blue-500 text-sm ml-2' onClick={() => setInfoHidden(!infoHidden)}>(help)</button>
   </h2>
   <div>
      <label className='hidden'>1. Save your Bing Customer ID and Account ID</label>
      <div className={`${infoHidden ? 'hidden' : 'block'} bg-slate-100 p-8 my-5`}>
        <img
          src={`${props.oauthCallbackBaseUrl}/assets/images/bing-account-id-marked.png`}
          alt="Location of Bing Account ID and Customer ID in URL"
        />
        <div className='mt-8'>
          Example
          <span className="block text-xs">
            https://ui.ads.microsoft.com/campaign/vnext/overview?aid=<span className="bg-amber-200">YOUR_ACCOUNT_ID</span>&cid=<span className="bg-teal-400">YOUR_CUSTOMER_ID</span>&uid=8675309
          </span>
        </div>

        <h3 className="mt-6">
          Use the Tool
        </h3>
        <div className='mt-0'>
          <label className='text-sm block mb-2' htmlFor='fb-ad-parse-tool'>
            Copy and paste your resolved <Link href="https://ui.ads.microsoft.com/campaign/vnext/overview" target="_blank">Bing Ads Dashboard</Link> below 
            to automatically extract your Customer and Account ID.
          </label>
          <input 
            id='fb-ad-parse-tool' 
            type="text" 
            className="border border-gray-300 rounded p-2 w-full" 
            onChange={(e) => handleExtractUrl(e.target.value)}
            placeholder='https://ui.ads.microsoft.com/campaign/vnext/overview?aid=YOUR_ACCOUNT_ID&cid=YOUR_CUSTOMER_ID&uid=8675309'
          />
        </div>
      </div>
    </div>
    <div>
          </div>
            <div>
              <label htmlFor="customer-id"  className='block mt-6 font-bold'>Customer ID</label>
      <div className="text-sm italic">
        Your Customer ID is found in 
        the <a href="https://ui.ads.microsoft.com/campaign/vnext/overview">
        Bing Ads dashboard URL</a> 
      </div>
              <input id="customer-id" 
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="321654987"
                value={ customerId }
                onChange={(e) => setCustomerId(e.target.value)}/>
            </div>
            <div>
              <label htmlFor="customer-account-id"  className='block mt-6 font-bold'>Account ID</label>
      <div className="text-sm italic">
        Your Account ID is found in 
        the <a href="https://ui.ads.microsoft.com/campaign/vnext/overview">
        Bing Ads dashboard URL</a> 
      </div>
              <input id="customer-account-id" 
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="789456123"
                value={ customerAccountId }
                onChange={(e) => setCustomerAccountId(e.target.value)} />
            </div>
            <div className='my-4'>
              <button 
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                onClick={() => handleSaveConfigData({customerId, customerAccountId})}
                type="button"
              >
                { saved ? ' ✔️ ' : 'Save'}
              </button>
            </div>

          2. Connect Bing { isConnected && <span className='text-green-500'>✅</span>}

          { !isConnected &&
            <div className='text-med'>
              <a className='inline-block border border-blue-500 bg-blue-500 text-white font-bold py-2 px-4 rounded mt-4'
                href={`https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${props.clientId}&response_type=code&redirect_uri=${props.oauthCallbackBaseUrl}/oauth-callback/bing&response_mode=query&scope=openid%20offline_access%20https%3A%2F%2Fads.microsoft.com%2Fmsads.manage&state=12345`}>
              Authorize Bing</a>
            </div>
          }
          { isConnected &&
            <div className='text-med'>
              <a 
                href={`https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${props.clientId}&response_type=code&redirect_uri=${props.oauthCallbackBaseUrl}/oauth-callback/bing&response_mode=query&scope=openid%20offline_access%20https%3A%2F%2Fads.microsoft.com%2Fmsads.manage&state=12345`}
              >
                Reauthenticate</a>

              <button 
                className=" text-red-800 hover:underline mt-4 px-4 rounded"
                onClick={() => handleDeleteConnection()}>Delete Connection
              </button>  
            </div>
          }
          <div className='block text-red-600'>{ error }</div>    
   </div>
  )
}

export default BingConnectedApp